<div class="p-4 flex justify-center">
    <div class="px-4 py-2 bg-white border border-gray-100 rounded overflow-clip">
        <h1>Not Found</h1>
    </div>
</div>